import _ from 'lodash'

import { userHasRole } from '_/vuex/actions/userActions'

import sessionChecker from '_/helpers/sessionChecker'

import { mapGetters, mapActions } from 'vuex'

import Vue from 'vue'

import { store } from '_/vuex/store'

import { router } from '_/router/router'

import { pError } from '_/helpers/logger'

import {
  destroyJsTree,
  setupJsTree,
} from '_/components/UserInterface/Sidebar/GeneratorSidebar/GeneratorSidebar.jsTree'

import {
  Assets,
  Breadcrumb,
  HelpBlock,
  MainMenu,
  SessionModal,
  Sidebar,
  TitleBlock,
  UserMenu,
} from '@/components'

const ModuleConfigurator = Vue.component(
  'ModuleConfigurator',
  require('_/components/Generator/ModuleConfigurator/ModuleConfigurator.vue')
    .default
)

const GeneratorInfoPanel = Vue.component(
  'GeneratorInfoPanel',
  require('_/components/Generator/GeneratorInfoPanel/GeneratorInfoPanel.vue')
    .default
)

const GeneratorHelpBlock = Vue.component(
  'GeneratorHelpBlock',
  require('_/components/Generator/GeneratorHelpBlock/GeneratorHelpBlock.vue')
    .default
)

export default {
  /**
   * Set the component's data storage
   *
   * @return  {void}
   */
  data: function() {
    return {
      /**
       * Session checker interval id
       *
       * @type  {number}
       */
      sessionCheckerIntervalId: null,
    }
  },

  /**
   * Set the beforeRouteEnter hook
   *
   * @return  {void}
   */
  beforeRouteEnter: function(to, from, next) {
    const moduleTableName = !_.isUndefined(to.params.moduleTableName)
      ? to.params.moduleTableName
      : false

    store
      .dispatch('photonModule/getPhotonModules', { refreshList: true })
      .then(() => {
        if (moduleTableName) {
          if (
            !store.state.photonModule.moduleTableNameToIdMap[moduleTableName]
          ) {
            pError("Photon module doesn't exist.", moduleTableName)

            router.push('/error/resource-not-found')

            return
          }
        }

        store
          .dispatch('generator/selectGeneratorModule', { moduleTableName })
          .then(() => {
            store.dispatch('generator/setGeneratorUi')

            next()
          })
      })
      .catch(error => {
        pError(
          'photonModule/getPhotonModules action failed with an error',
          error
        )

        router.push('/error/resource-not-found')
      })
  },

  /**
   * Set the computed properties
   *
   * @type {object}
   */
  computed: {
    ...mapGetters({
      generator: 'generator/generator',
      ui: 'ui/ui',
      user: 'user/user',
    }),
  },

  /**
   * Set the components
   *
   * @type  {Object}
   */
  components: {
    Assets,
    Breadcrumb,
    GeneratorHelpBlock,
    GeneratorInfoPanel,
    HelpBlock,
    MainMenu,
    ModuleConfigurator,
    Sidebar,
    TitleBlock,
    UserMenu,
    SessionModal,
  },

  /**
   * Set the methods
   *
   * @type  {Object}
   */
  methods: {
    ...mapActions('generator', [
      'generatorCleanup',
      'selectGeneratorModule',
      'setGeneratorUi',
    ]),

    ...mapActions('photonModule', [
      'getPhotonModules',
      'getPhotonModuleInformation',
    ]),

    ...mapActions('sidebar', ['setSidebarType']),

    ...mapActions('ui', [
      'animateWrapper',
      'emptyFilteredLocales',
      'setBodyClass',
    ]),

    /**
     * Triggers the create mode
     *
     * @return  {void}
     */
    createNewModule() {
      router.push('/generator')
    },

    /**
     * getPhotonModules method wrapper
     *
     * @return  {promise}
     */
    getPhotonModulesHelper(moduleTableName) {
      return this.getPhotonModules({ refreshList: true })
        .then(() => {
          if (moduleTableName) {
            if (
              !store.state.photonModule.moduleTableNameToIdMap[moduleTableName]
            ) {
              pError("Photon module doesn't exist.", moduleTableName)

              router.push('/error/resource-not-found')

              return
            }
          }

          return this.selectGeneratorModule({ moduleTableName }).then(() => {
            return this.setGeneratorUi()
          })
        })
        .catch(error => {
          pError(
            'photonModule/getPhotonModules action failed with an error',
            error
          )

          router.push('/error/resource-not-found')
        })
    },
  },

  /**
   * Set the mounted hook
   *
   * @return  {void}
   */
  mounted: function() {
    this.$nextTick(function() {
      this.emptyFilteredLocales()

      if (!userHasRole('super_administrator')) {
        router.push('/error/resource-not-found')
      }

      this.setBodyClass('generator')

      this.setSidebarType('GeneratorSidebar')

      this.animateWrapper()

      this.setGeneratorUi()

      this.sessionCheckerIntervalId = sessionChecker.setCheckerInterval()
    })
    //make mobile controll buttons sticly
    const top = $('.mobile-control-buttons').offset().top
    $(window).scroll(function() {
      const y = $(this).scrollTop()
      if (y >= top) $('.mobile-control-buttons').addClass('fixed')
      else {
        $('.mobile-control-buttons').removeClass('fixed')
      }
      $('.sticky-scroll-box').width(
        $('.sticky-scroll-box')
          .parent()
          .width()
      )
    })
  },

  /**
   * Define watched properties
   *
   * @type  {Object}
   */
  watch: {
    $route(newEntry) {
      const moduleTableName = newEntry.params.moduleTableName

      this.getPhotonModulesHelper(moduleTableName)
    },

    'generator.refreshForm'() {
      const moduleTableName = this.generator.selectedModule.table_name

      this.getPhotonModulesHelper(moduleTableName).then(() => {
        destroyJsTree()

        setupJsTree(this)
      })
    },

    'generator.selectedModule.id'() {
      this.$nextTick(() => {
        $(this.$el)
          .find('.scrollable')
          .first()
          .scrollTop(0)
      })
    },
  },

  /**
   * Set the beforeDestroy hook
   *
   * @return  {void}
   */
  beforeDestroy: function() {
    this.generatorCleanup()

    this.setSidebarType(null)

    clearInterval(this.sessionCheckerIntervalId)

    this.sessionCheckerIntervalId = null
  },
}
